import React from 'react';

export const UserContext = React.createContext({
    user: null,
    setUser: () => {},
    isAuthenticated: false,
    setIsAuthenticated: () => {},
    userData: null,
    setUserData: () => {}
  });